import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ce16fffa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card" }
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = { class: "card-title" }
const _hoisted_5 = { class: "card-subtitle fw-bold" }
const _hoisted_6 = { class: "card-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      src: _ctx.product.image,
      class: "card-img-top",
      alt: `Изображение "${_ctx.product.name}"`
    }, null, 8, _hoisted_2),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("h5", _hoisted_4, _toDisplayString(_ctx.product.name), 1),
      _createElementVNode("h6", _hoisted_5, "$" + _toDisplayString(_ctx.product.price), 1),
      _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.product.description), 1),
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.addToCart && _ctx.addToCart(...args))),
        class: "btn btn-primary"
      }, "Добавить в корзину")
    ])
  ]))
}